import React from "react";

export default function About(){
    return (
        <div>
          <h1 class="bg-primary ">About Swizzle.fun</h1>
        </div>
      );
}